import React, { useEffect, useRef, useState } from 'react';

// Never autoplay: reduced-motion visitors get the same static, opt-in poster.
// At rest, no native controls -- just the poster and one centered play
// button. Clicking it hides the button, shows native controls, and starts
// playback.
const JuniperVideo: React.FC = () => {
  const [failed, setFailed] = useState(false);
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  // Once `playing` flips, the button unmounts and `controls` is applied to
  // the video in the same render -- move focus there after that DOM update
  // lands, so a keyboard user doesn't lose their place when the button they
  // were focused on disappears.
  useEffect(() => {
    if (playing) videoRef.current?.focus();
  }, [playing]);

  if (failed) return <>
    <img src="/showcase/juniper-member-studio-v1-poster.jpg" alt="Juniper beside a fictional adult Pilates member in an illustrated studio" width={1280} height={720} />
    <p className="video-fallback" role="status">Video unavailable. The illustrated scene is shown instead.</p>
  </>;

  const handlePlay = () => {
    setPlaying(true);
    // play() returns a promise that rejects if the browser blocks it; the
    // native controls are already showing by then, so the user can just
    // press play themselves -- nothing else to do on rejection.
    videoRef.current?.play().catch(() => {});
  };

  return (
    <>
      <video
        ref={videoRef}
        aria-label="Juniper and a fictional Pilates member"
        src="/showcase/juniper-member-studio-v1.mp4"
        poster="/showcase/juniper-member-studio-v1-poster.jpg"
        controls={playing}
        muted
        playsInline
        preload="none"
        width={1280}
        height={720}
        onError={() => setFailed(true)}
      />
      {!playing && (
        <button
          type="button"
          className="juniper-play"
          aria-label="Play Juniper video"
          onClick={handlePlay}
        />
      )}
    </>
  );
};
export default JuniperVideo;
